<script lang="ts">
	import MentionsInner from '$lib/components/TextEditor/Components/Popovers/Mention/MentionsInner.svelte';
	import { getHubStores } from '$lib/stores/hubStores';
	import type { MentionOptions } from '@tiptap/extension-mention';
	import tippy, { type Instance, type GetReferenceClientRect } from 'tippy.js';

	type mentionPropsProp = { id: string; label: string };
	let mentionsProps: {
		command: (props: mentionPropsProp) => void;
	};
	let mentionsPopover: HTMLElement;
	const { restApi, hub } = getHubStores();

	let mentionsUserStore: Array<{ id: string; type: string; name: string; avatar_url: string }> = [];
	let selectedIndex = 0;

	export const mentionsTipTap: MentionOptions['suggestion'] = {
		items: async ({ query }) => {
			const response = await restApi.userMentions(query, $hub.id);
			const users = response.data ?? [];
			mentionsUserStore = users;
			return users.map((e) => e.name);
		},
		render: () => {
			let popup: Instance[];
			return {
				onStart: (props) => {
					popup = tippy('body', {
						getReferenceClientRect: props.clientRect as GetReferenceClientRect,
						appendTo: () => document.body,
						content: mentionsPopover,
						showOnCreate: true,
						interactive: true,
						trigger: 'manual',
						placement: 'bottom-start',
					});
					mentionsProps = props;
				},
				onUpdate: (props) => {
					popup[0].setProps({
						getReferenceClientRect: props.clientRect as GetReferenceClientRect,
					});
				},
				onExit() {
					popup[0].destroy();
					mentionsUserStore = [];
				},

				onKeyDown: (props) => {
					const moveIndex = (direction: 'up' | 'down') => {
						if (direction === 'down') {
							selectedIndex === mentionsUserStore.length - 1
								? (selectedIndex = 0)
								: selectedIndex++;
						} else {
							selectedIndex === 0
								? (selectedIndex = mentionsUserStore.length - 1)
								: selectedIndex--;
						}
					};

					if (props.event.key === 'ArrowDown') {
						moveIndex('down');
						props.event.preventDefault();
					} else if (props.event.key === 'ArrowUp') {
						moveIndex('up');
						props.event.preventDefault();
					} else if (props.event.key === 'Enter') {
						submitChoice();
						props.event.preventDefault();
						return true;
					}

					return false;
				},
			};
		},
	};

	const submitChoice = () => {
		mentionsProps.command({
			id: mentionsUserStore[selectedIndex].id,
			label: mentionsUserStore[selectedIndex].name,
		});
		mentionsUserStore = [];
	};
</script>

<div class="mentions" bind:this={mentionsPopover}>
	<MentionsInner bind:mentionsUserStore bind:selectedIndex {submitChoice} />
</div>

<style>
	:global(.ProseMirror .mention) {
		background-color: #d7e5f9;
	}

	:global(.ProseMirror .mention:hover) {
		background-color: #e8eff9;
	}
</style>
